import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/reviews-quote.webp")